module.exports = __webpack_public_path__ + "static/media/presentation_clinic.3ca0442e.jpg";